"use client";

import { useEffect } from "react";

import { getOrCreateFirstTouchTrafficSource } from "@/utils/trafficSource";

/**
 * 앱 첫 로드 시 first-touch 유입 출처를 1회 캡처한다. 모든 라우트에서 마운트되도록
 * 루트 레이아웃에 둔다(DatadogRumInit / ConversionTrackingInit과 동일 패턴).
 */
export default function FirstTouchInit() {
  useEffect(() => {
    getOrCreateFirstTouchTrafficSource();
  }, []);

  return null;
}
